import { css } from 'emotion';

export namespace styles {
  export const container = (offset: number, outOfBoundaries: boolean) =>
    css({
      marginTop: offset,
      backgroundColor: 'white',
      boxShadow: '0px 14px 24px -14px rgba(0,0,0,0.2)',
      border: '1px solid #EBEBEB',
      zIndex: 10,
      top: outOfBoundaries ? 'initial' : undefined,
      cursor: 'initial'
    });
}
